<!-- ═══ Modal overlay ═══ -->
<div
  class="fixed inset-0 z-[100] flex items-start justify-center p-4 pt-24"
  (click)="close()"
>
  <!-- Backdrop -->
  <div class="absolute inset-0 bg-black/50 backdrop-blur-sm"></div>

  <!-- Modal body -->
  <div
    class="relative z-10 w-full max-w-2xl max-h-[90vh] flex flex-col rounded-2xl shadow-2xl overflow-hidden"
    [ngClass]="{
      'bg-white dark:bg-slate-800': merchantType === 'fixed',
      'bg-slate-900': merchantType === 'itinerant',
    }"
    (click)="$event.stopPropagation()"
  >
    <!-- ─── Toolbar ─── -->
    <div
      class="flex items-center justify-between px-5 py-3 border-b"
      [ngClass]="{
        'border-gray-200 dark:border-slate-700': merchantType === 'fixed',
        'border-slate-700': merchantType === 'itinerant',
      }"
    >
      <h2
        class="text-lg font-bold"
        [ngClass]="{
          'text-gray-800 dark:text-white': merchantType === 'fixed',
          'text-amber-100': merchantType === 'itinerant',
        }"
      >
        📋 Carte du menu
      </h2>

      <div class="flex items-center gap-2">
        <!-- Export PNG -->
        <button
          (click)="exportPNG()"
          [disabled]="exporting || loading"
          class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold rounded-lg transition-colors"
          [ngClass]="{
            'bg-purple-100 text-purple-700 hover:bg-purple-200 dark:bg-purple-900/30 dark:text-purple-300':
              merchantType === 'fixed',
            'bg-amber-800/40 text-amber-200 hover:bg-amber-800/60':
              merchantType === 'itinerant',
          }"
          title="Exporter en image PNG"
        >
          🖼️ PNG
        </button>
        <!-- Export PDF -->
        <button
          (click)="exportPDF()"
          [disabled]="exporting || loading"
          class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold rounded-lg transition-colors"
          [ngClass]="{
            'bg-red-100 text-red-700 hover:bg-red-200 dark:bg-red-900/30 dark:text-red-300':
              merchantType === 'fixed',
            'bg-red-800/40 text-red-200 hover:bg-red-800/60':
              merchantType === 'itinerant',
          }"
          title="Exporter en PDF"
        >
          📄 PDF
        </button>
        <!-- Close -->
        <button
          (click)="close()"
          class="ml-2 p-1.5 rounded-lg transition-colors"
          [ngClass]="{
            'hover:bg-gray-100 dark:hover:bg-slate-700 text-gray-500 dark:text-gray-400':
              merchantType === 'fixed',
            'hover:bg-slate-700 text-slate-400': merchantType === 'itinerant',
          }"
        >
          ✕
        </button>
      </div>
    </div>

    <!-- ─── Scrollable menu content ─── -->
    <div class="flex-1 overflow-y-auto">
      @if (loading) {
        <div class="flex items-center justify-center py-20">
          <div
            class="animate-spin h-8 w-8 border-4 border-purple-500 border-t-transparent rounded-full"
          ></div>
        </div>
      } @else if (categories.length === 0) {
        <div class="text-center py-20 text-gray-400 dark:text-slate-500">
          <p class="text-4xl mb-3">🍽️</p>
          <p class="font-semibold">Aucun produit actif</p>
          <p class="text-sm mt-1">
            Ajoutez des produits depuis l'inventaire pour créer votre carte.
          </p>
        </div>
      } @else {
        <!-- ═══ Exportable area ═══ -->
        <div #menuContent>
          <!-- ──────────────────────────────────────────────────────────── -->
          <!--  STYLE FIXE : Carte restaurant élégante                    -->
          <!-- ──────────────────────────────────────────────────────────── -->
          @if (merchantType === "fixed") {
            <div class="menu-fixed bg-white dark:bg-slate-800 px-8 py-8">
              <!-- Header -->
              <div
                class="text-center mb-8 pb-6 border-b-2 border-purple-200 dark:border-purple-800"
              >
                <h1
                  class="font-serif text-3xl font-bold text-gray-900 dark:text-white tracking-wide"
                >
                  {{ businessName }}
                </h1>
                <p
                  class="text-sm text-purple-600 dark:text-purple-400 mt-2 uppercase tracking-widest"
                >
                  Notre Carte — {{ totalProducts }} produits
                </p>
                <div
                  class="mt-3 flex items-center justify-center gap-3 text-purple-300 dark:text-purple-700"
                >
                  <span class="h-px flex-1 max-w-16 bg-current"></span>
                  <span>✦</span>
                  <span class="h-px flex-1 max-w-16 bg-current"></span>
                </div>
              </div>

              <!-- Categories -->
              @for (cat of categories; track cat.name) {
                <div class="mb-7">
                  <h2
                    class="flex items-center gap-2 text-lg font-bold text-purple-700 dark:text-purple-400 mb-4 uppercase tracking-wider"
                  >
                    <span>{{ cat.icon }}</span>
                    <span>{{ cat.name }}</span>
                    <span
                      class="flex-1 h-px bg-purple-200 dark:bg-purple-800 ml-2"
                    ></span>
                  </h2>

                  <div class="space-y-2.5">
                    @for (product of cat.products; track product.id) {
                      <div
                        class="flex items-baseline justify-between gap-2 group"
                      >
                        <div class="flex items-baseline gap-2 min-w-0 flex-1">
                          <span
                            class="font-semibold text-gray-800 dark:text-gray-100 text-sm"
                          >
                            {{ product.name }}
                          </span>
                          <span
                            class="flex-1 border-b border-dotted border-gray-300 dark:border-slate-600 min-w-4"
                          ></span>
                        </div>
                        @if (product.sellPrice) {
                          <span
                            class="font-bold text-purple-700 dark:text-purple-400 text-sm whitespace-nowrap"
                          >
                            {{ formatPrice(product.sellPrice) }}
                          </span>
                        }
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          }

          <!-- ──────────────────────────────────────────────────────────── -->
          <!--  STYLE ITINÉRANT : Ardoise food truck                      -->
          <!-- ──────────────────────────────────────────────────────────── -->
          @if (merchantType === "itinerant") {
            <div class="menu-itinerant bg-slate-900 px-8 py-8">
              <!-- Header -->
              <div class="text-center mb-8 pb-6 border-b border-amber-600/40">
                <h1
                  class="font-chalk text-3xl font-extrabold text-amber-100 tracking-wide"
                >
                  🚚 {{ businessName }}
                </h1>
                <p
                  class="text-sm text-amber-400/70 mt-2 uppercase tracking-widest"
                >
                  Notre Menu — {{ totalProducts }} produits
                </p>
                <div
                  class="mt-3 flex items-center justify-center gap-3 text-amber-600/50"
                >
                  <span class="h-px flex-1 max-w-16 bg-current"></span>
                  <span>★</span>
                  <span class="h-px flex-1 max-w-16 bg-current"></span>
                </div>
              </div>

              <!-- Categories -->
              @for (cat of categories; track cat.name) {
                <div class="mb-7">
                  <h2
                    class="flex items-center gap-2 text-lg font-extrabold text-amber-300 mb-4 uppercase tracking-wider"
                  >
                    <span>{{ cat.icon }}</span>
                    <span>{{ cat.name }}</span>
                    <span class="flex-1 h-px bg-amber-700/40 ml-2"></span>
                  </h2>

                  <div class="space-y-3">
                    @for (product of cat.products; track product.id) {
                      <div class="flex items-baseline justify-between gap-2">
                        <div class="flex items-baseline gap-2 min-w-0 flex-1">
                          <span class="font-semibold text-amber-100 text-sm">
                            {{ product.name }}
                          </span>
                          <span
                            class="flex-1 border-b border-dotted border-amber-800/40 min-w-4"
                          ></span>
                        </div>
                        @if (product.sellPrice) {
                          <span
                            class="font-bold text-amber-400 text-sm whitespace-nowrap"
                          >
                            {{ formatPrice(product.sellPrice) }}
                          </span>
                        }
                      </div>
                    }
                  </div>
                </div>
              }

              <!-- Footer -->
              <div class="mt-8 pt-4 border-t border-amber-600/30 text-center">
                <p class="text-xs text-amber-600/50 italic">
                  Tous nos produits sont faits maison • Prix TTC
                </p>
              </div>
            </div>
          }
        </div>
      }
    </div>

    <!-- ─── Exporting overlay ─── -->
    @if (exporting) {
      <div
        class="absolute inset-0 bg-black/30 flex items-center justify-center z-20 rounded-2xl"
      >
        <div
          class="bg-white dark:bg-slate-800 rounded-xl px-6 py-4 flex items-center gap-3 shadow-xl"
        >
          <div
            class="animate-spin h-5 w-5 border-3 border-purple-500 border-t-transparent rounded-full"
          ></div>
          <span class="text-sm font-semibold text-gray-700 dark:text-gray-200"
            >Export en cours…</span
          >
        </div>
      </div>
    }
  </div>
</div>
